module.exports = __webpack_public_path__ + "img/btn_search_bidv.b91575ef.svg";